import React from 'react';
import AirlineDetailPage from '../components/AirlineDetailPage';
import { DELTA_AIR_LINES } from '../data/airlinesData';

export default function DeltaAirLinesPage() {
  return <AirlineDetailPage airline={DELTA_AIR_LINES} />;
}
